import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toggleFilter } from "../../../store/actions/documentsWithSearch";
import { Radio, Select } from "antd";
import moment from "moment";
import URI from "urijs";
import { FormattedMessage, useIntl } from "react-intl";
import Collapsed from "../../general/collapsed";
import { VaporChip, VaporInput, VaporRangeDatePicker } from "../../vapor";

import "../style.css";

const { Option } = Select;

const useStateChipGroup = ({ month, quarter, semester }) => {
  const [chipGroup, setChipGroup] = React.useState(["all", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"]);

  const handleChange = (value) => {
    switch (value) {
      case month:
        setChipGroup(["all", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"]);
        break;
      case quarter:
        setChipGroup(["all", "first", "second", "third", "fourth"]);
        break;
      case semester:
        setChipGroup(["all", "first", "second"]);
        break;
      default:
        break;
    }
  };
  return [chipGroup, handleChange];
};

const Filters = (props) => {
  const { handleGetDocumentsWithSearch } = props;

  const dispatch = useDispatch();
  // BEGIN REDUX STATE
  const filters = useSelector((state) => state.documentsWithSearch.filters);
  const user = useSelector((state) => state.user);
  const currentLink = useSelector((state) => state.documentsWithSearch.currentLink) || "";
  const txtSearch = useSelector((state) => state.documentsWithSearch.txtSearch);
  const resetAllFilters = filters.status.reset;
  // END REDUX STATE
  const month = useIntl().formatMessage({ id: "documents.filters.month" });
  const quarter = useIntl().formatMessage({ id: "documents.filters.quarter" });
  const semester = useIntl().formatMessage({ id: "documents.filters.semester" });
  const allWord = useIntl().formatMessage({ id: "generic.all" });
  // USE STATE
  const [startDate, setStartDate] = React.useState(null);
  const [endDate, setEndDate] = React.useState(null);
  const [typeDateFilter, setTypeDateFilter] = React.useState("created_on");
  const [yearFilter, setYearFilter] = React.useState(allWord);
  const [periodFilter, setPeriodFilter] = React.useState(month);
  const [chipGroup, setChipGroup] = useStateChipGroup({ month, quarter, semester });
  const [chipActive, setChipActive] = React.useState(0);

  const [invoiceType, setInvoiceType] = React.useState(allWord);

  const [invoiceNumber, setInvoiceNumber] = React.useState("");
  const [debounceInvoiceNumber, setDebounceInvoiceNumber] = React.useState(null);

  useEffect(() => {
    if (!currentLink) return;
    let uri = new URI(currentLink);

    let parameter = uri.search(true);

    if (parameter.filterFromDate && parameter.filterToDate) {
      setEndDate(parameter.filterToDate);
      setStartDate(parameter.filterFromDate);
      parameter.filterOnField && setTypeDateFilter(parameter.filterOnField);
    } else {
      setEndDate(null);
      setStartDate(null);
      setTypeDateFilter("created_on");
      setYearFilter(allWord);
      setPeriodFilter(month);
      setChipGroup({ month, quarter, semester });
    }
    if (!parameter.microcategory) {
      setInvoiceType(allWord);
    }
    if (!parameter.invoiceNumber) setInvoiceNumber("");
  }, [currentLink]);

  useEffect(() => {
    if (resetAllFilters) {
      setStartDate(null);
      setEndDate(null);
      setTypeDateFilter("created_on");
      setYearFilter(allWord);
      setPeriodFilter(month);
      setChipGroup({ month, quarter, semester });
      setChipActive(0);
      setInvoiceNumber("");
    }
  }, []);

  const handleInvoiceNumber = (value) => {
    if (window.aptrinsic) {
      window.aptrinsic("track", "digital-box:DOCUMENTS-FILTER-NUMBER");
    }
    setInvoiceNumber(value);
    if (debounceInvoiceNumber !== null) clearTimeout(debounceInvoiceNumber);

    setDebounceInvoiceNumber(
      setTimeout(() => {
        if (value === "")
          dispatchAction({
            link: currentLink,
            removeProps: ["invoiceNumber"],
          });
        else
          dispatchAction({
            link: currentLink,
            additionalProps: {
              invoiceNumber: value,
            },
          });
      }, 500)
    );
  };

  const dispatchAction = ({ link, isAppend = false, additionalProps = null, removeProps = [] }) => {
    handleGetDocumentsWithSearch({ link, isAppend, additionalProps, removeProps, search: txtSearch });
  };

  const renderOtherFilters = (item, key) => {
    let arrayObj = [];
    item.links.map((el, key) => {
      let linkSelf = el._links.self.href;
      let currentLinkEpured = currentLink;

      /** per ovviare ai duplicati nelle labels che non rendono attiva la voce delle mie etichette  */
      if (linkSelf && currentLinkEpured) {
        const splittedLink = linkSelf.split("&labels=");
        let splittedLabels = splittedLink[1] ? splittedLink[1].split(",") : [];
        splittedLabels = splittedLabels.filter((val, idx, self) => {
          return idx === self.indexOf(val);
        });
        linkSelf = splittedLink[0] + (splittedLabels.length > 0 ? "&labels=" + splittedLabels.join(",") : "");

        const splittedCurrentLink = currentLinkEpured.split("&labels=");
        let splittedCurrentLabels = splittedCurrentLink[1] ? splittedCurrentLink[1].split(",") : [];
        splittedCurrentLabels = splittedCurrentLabels.filter((val, idx, self) => {
          return idx === self.indexOf(val);
        });
        currentLinkEpured = splittedCurrentLink[0] + (splittedCurrentLabels.length > 0 ? "&labels=" + splittedCurrentLabels.join(",") : "");
      }
      // http://medialize.github.io/URI.js/docs.html#equals
      // Siccome i link dei filtri possono cambiare l'ordine dei parametri usiamo una libreria "uijs" per vedere se le url sono equivalenti
      arrayObj.push(
        <div
          key={key}
          className={URI(currentLinkEpured).equals(linkSelf) ? "linkFilter gs-documents-side-filter active" : "linkFilter gs-documents-side-filter"}
          onClick={() => {
            if (currentLink !== linkSelf) {
              dispatchAction({ link: linkSelf });
            }
          }}
        >
          {el.label} ({el.count})
        </div>
      );
      return arrayObj;
    });

    return (
      <Collapsed
        key={"history"}
        isCollapsed={item.collapsed}
        onClick={(e) => {
          dispatch(toggleFilter(key));
        }}
        title={<FormattedMessage id={"documents.filters.otherFilters." + item.title} defaultMessage={item.title} />}
      >
        {arrayObj}
      </Collapsed>
    );
  };

  const renderFilterForYears = () => {
    const changeYear = (year) => {
      setYearFilter(year);
      if (year === allWord) {
        dispatchAction({ removeProps: ["filterFromDate", "filterToDate"] });
      } else newChipsSelected({ year });
    };
    const renderRange = (start, end) => {
      let items = [];
      for (let i = start; i <= end; i++) {
        items.push(
          <Option key={i} value={i}>
            {i}
          </Option>
        );
      }
      return items;
    };

    return (
      <Select style={{ width: "90px", marginRight: "20px" }} value={yearFilter} onChange={(value) => changeYear(value)}>
        {renderRange(moment().subtract(10, "years").format("YYYY"), moment().format("YYYY"))}
        <Option key={allWord} value={allWord}>
          {allWord}
        </Option>
      </Select>
    );
  };

  const renderFilterForPeriod = () => {
    const handlePeriodChange = (value) => {
      setPeriodFilter(value);
      setChipGroup(value);
      newChipsSelected({ index: 0 });
    };
    return (
      <Select style={{ width: "160px" }} value={periodFilter} onChange={(value) => handlePeriodChange(value)}>
        {[month, quarter, semester].map((item, key) => {
          return (
            <Option key={key} value={item}>
              {item}
            </Option>
          );
        })}
      </Select>
    );
  };

  const newChipsSelected = ({ index = chipActive, year = yearFilter }) => {
    let fromDate = "";
    let toDate = "";
    if (index === 0) {
      fromDate = moment(new Date(year, 0, 1));
      toDate = moment(new Date(year, 12, 0));
    } else {
      if (periodFilter === month) {
        fromDate = moment(new Date(year, index - 1, 1));
        toDate = moment(new Date(year, index, 0));
      }
      if (periodFilter === quarter) {
        fromDate = moment(new Date(year, (index - 1) * 3, 1));
        toDate = moment(new Date(year, index * 3, 0));
      }
      if (periodFilter === semester) {
        fromDate = moment(new Date(year, (index - 1) * 6, 1));
        toDate = moment(new Date(year, index * 6, 0));
      }
    }
    setChipActive(index);
    const parameters = {
      filterFromDate: fromDate.format("YYYY-MM-DD"),
      filterToDate: toDate.format("YYYY-MM-DD"),
    };

    dispatchAction({ link: currentLink, additionalProps: parameters });
  };

  const radioStyle = {
    display: "block",
    height: "30px",
    lineHeight: "30px",
  };

  const handleInvoiceType = (value) => {
    setInvoiceType(value);
    let parameters = {},
      removeParameters = [];
    switch (value) {
      case "sell":
        parameters["microcategory"] = "Fatture+emesse";
        break;
      case "buy":
        parameters["microcategory"] = "Fatture+ricevute";
        break;
      default:
        removeParameters.push("microcategory");
    }
    if (startDate && endDate) {
      parameters["filterFromDate"] = startDate;
      parameters["filterToDate"] = endDate;
    }
    dispatchAction({
      link: currentLink,
      additionalProps: parameters,
      removeProps: removeParameters,
    });
  };

  // serve per filtro ultimo trimestre
  // let actualMonth = moment().month() + 1;
  return (
    <div className="document-filters">
      {currentLink.includes("macrocategory=Fatture") && (
        <React.Fragment>
          <div className="title">
            <FormattedMessage id="documents.filters.invoiceTypology" />
          </div>
          <Select style={{ width: "100%", marginBottom: "25px" }} value={invoiceType} onChange={(value) => handleInvoiceType(value)}>
            <Option value={allWord}>{allWord}</Option>
            <Option value={"sell"}>{"Vendita"}</Option>
            <Option value={"buy"}>{"Acquisto"}</Option>
          </Select>
        </React.Fragment>
      )}
      <div className="title">
        <FormattedMessage id="documents.filters.selectPeriod" />
      </div>
      <Radio.Group
        onChange={(e) => {
          setTypeDateFilter(e);
          dispatchAction({
            link: currentLink,
            additionalProps: {
              filterOnField: e.target.value,
            },
          });
        }}
        style={{ marginBottom: "16px", display: "flex" }}
        value={typeDateFilter}
        disabled={!startDate || !endDate}
      >
        <Radio style={radioStyle} value={"created_on"}>
          <FormattedMessage id="documents.filters.typeDate.create" />
        </Radio>
        <Radio style={radioStyle} value={"referencing_date"}>
          <FormattedMessage id="documents.filters.typeDate.document" />
        </Radio>
      </Radio.Group>
      <VaporRangeDatePicker
        locale={user?.profile?.language === "es-ES" ? "es" : "it"}
        className="rangeFilter"
        placeholder={[useIntl().formatMessage({ id: "documents.filters.fromDate" }), useIntl().formatMessage({ id: "documents.filters.toDate" })]}
        dropdownClassName="dropdownFilter"
        suffixIconStyle={{ marginRight: "-5px" }}
        onChange={(e) => {
          if (e && e.length !== 0) {
            setStartDate(e[0]?.format("YYYY-MM-DD"));
            setEndDate(e[1]?.format("YYYY-MM-DD"));
            dispatchAction({
              link: currentLink,
              additionalProps: {
                filterFromDate: moment(e[0]).format("YYYY-MM-DD"),
                filterToDate: moment(e[1]).format("YYYY-MM-DD"),
                filterOnField: typeDateFilter,
              },
            });
          } else {
            setStartDate(null);
            setEndDate(null);
            setYearFilter(allWord);
            setPeriodFilter(month);
            dispatchAction({
              additionalProps: {
                filterOnField: typeDateFilter,
              },
              removeProps: ["filterFromDate", "filterToDate"],
            });
          }
        }}
        value={[startDate ? moment(startDate, "YYYY-MM-DD") : null, endDate ? moment(endDate, "YYYY-MM-DD") : null]}
      />

      {currentLink.includes("macrocategory=Fatture") && (
        <VaporInput label="Numero documento" style={{ marginBottom: "25px" }} value={invoiceNumber} onChange={(e) => handleInvoiceNumber(e.target.value)} />
      )}

      <div className="title">
        <FormattedMessage id="documents.filters.filterFor" />
      </div>
      <div className="dropdown-group">
        {renderFilterForYears()}
        {yearFilter !== allWord && renderFilterForPeriod()}
      </div>
      {yearFilter !== allWord && (
        <React.Fragment>
          <div className="title">
            <FormattedMessage id="documents.filters.selectMonths" />
          </div>
          <div className="chip-group">
            {chipGroup.map((period, index) => {
              let id = ["all", "first", "second", "third", "fourth"].includes(period) ? "generic." + period : "generic.months." + period;
              id = useIntl().formatMessage({ id: id });
              return <VaporChip key={period} title={id} onClick={() => newChipsSelected({ index })} active={index === chipActive} />;
            })}
          </div>
        </React.Fragment>
      )}
      {filters.list && filters.list.length > 0 ? (
        <div style={{ color: "#152935", marginBottom: "8px", marginTop: "40px" }}>
          <div className="title">
            <FormattedMessage id="documents.filters.others" />
          </div>
          {filters.list.map(
            (item, key) => item.title !== "Macro Categoria" && <React.Fragment key={"filerK_" + key}> {renderOtherFilters(item, key)}</React.Fragment>
          )}
        </div>
      ) : null}
    </div>
  );
};

export default Filters;
